import React, { PureComponent } from 'react'
import './listEditable.component.css'

class ListEditable extends PureComponent {
  render () {
    const { children } = this.props

    return (
      <div className='list-editable'>
        {children}
      </div>
    )
  }
}

export default ListEditable
